import {
   HealthcareProviderElectronicDocumentIssuedNotificationConfigurationQuery,
   HealthcareProviderNotificationConfiguration,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PatientPhoneNotificationElectronicDocumentIssuedToggleLoaderResult = {
   notificationEnabled: boolean;
   messages: string[];
   refetch: VoidFunction;
};

type PatientPhoneNotificationElectronicDocumentIssuedToggleLoaderProps = {
   readonly children: (result: PatientPhoneNotificationElectronicDocumentIssuedToggleLoaderResult) => JSX.Element;
};

export const PatientPhoneNotificationElectronicDocumentIssuedToggleLoader = (
   props: PatientPhoneNotificationElectronicDocumentIssuedToggleLoaderProps
): JSX.Element | null => {
   const {
      data: healthcareProviderNotificationConfiguration,
      loading: healthcareProviderNotificationConfigurationLoading,
      error: healthcareProviderNotificationConfigurationError,
      refetch,
   } = useCqrsGet<HealthcareProviderNotificationConfiguration>(() => {
      return new HealthcareProviderElectronicDocumentIssuedNotificationConfigurationQuery();
   });

   if (
      healthcareProviderNotificationConfigurationLoading ||
      healthcareProviderNotificationConfigurationError ||
      !healthcareProviderNotificationConfiguration
   ) {
      return null;
   }

   return props.children({
      notificationEnabled: healthcareProviderNotificationConfiguration.enabled,
      messages: healthcareProviderNotificationConfiguration.messages,
      refetch: refetch,
   });
};
